import { Input, Password, Email, InputNumber, Tel } from './web';
Input.Password = Password;
Input.Email = Email;
Input.Number = InputNumber;
Input.Tel = Tel;
export default Input;